import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {Building2, GraduationCap, Briefcase, Users, CheckCircle, ArrowRight} from 'lucide-react'

const convenios = [
  {
    icon: Building2,
    title: "Empresas",
    text: "Programas de inglês corporativo com condições especiais para colaboradores. Planos personalizados de acordo com o porte e necessidade da empresa.",
    benefits: ["Descontos exclusivos para colaboradores", "Relatórios de progresso", "Suporte dedicado ao RH"],
    color: "#0E8EA0",
  },
  {
    icon: GraduationCap,
    title: "Universidades e Escolas",
    text: "Parcerias com instituições de ensino para oferecer inglês complementar aos alunos com condições diferenciadas.",
    benefits: ["Acesso à plataforma EW Academy", "Integração com grade curricular", "Certificados reconhecidos"],
    color: "#B038B2",
  },
  {
    icon: Briefcase,
    title: "Sindicatos e Associações",
    text: "Convênios com sindicatos, associações profissionais e entidades de classe para beneficiar seus associados.",
    benefits: ["Planos coletivos com desconto", "Atendimento personalizado", "Flexibilidade de pagamento"],
    color: "#F5C542",
  },
  {
    icon: Users,
    title: "ONGs e Instituições Sociais",
    text: "Programas especiais para organizações sociais que desejam oferecer inglês aos seus beneficiários.",
    benefits: ["Bolsas parciais e integrais", "Material didático incluso", "Acompanhamento pedagógico"],
    color: "#6CC4C4",
  },
]

export default function Convenios() {
  const section1 = useScrollReveal()

  return (
    <>
      <PageHero
        title="Nossos Convênios"
        subtitle="Parcerias estratégicas para levar o inglês a mais pessoas com condições especiais."
      />

      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <p className="text-center text-gray-600 max-w-2xl mx-auto mb-14 leading-relaxed">
            A English Work mantém convênios com empresas, universidades, sindicatos e instituições para democratizar o acesso ao aprendizado de inglês com condições exclusivas.
          </p>
          <div className="grid md:grid-cols-2 gap-8">
            {convenios.map((item) => (
              <div
                key={item.title}
                className="rounded-2xl p-8 border border-gray-100 hover:shadow-lg transition-all duration-300"
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mb-5"
                  style={{ backgroundColor: `${item.color}15` }}
                >
                  <item.icon size={26} style={{ color: item.color }} />
                </div>
                <h3 className="text-xl font-bold mb-2 text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-5">{item.text}</p>
                <ul className="space-y-2 mb-5">
                  {item.benefits.map((b) => (
                    <li key={b} className="flex items-center gap-2 text-sm text-gray-700">
                      <CheckCircle size={16} style={{ color: item.color }} className="shrink-0" />
                      {b}
                    </li>
                  ))}
                </ul>
                <a
                  href="/fale-conosco"
                  className="inline-flex items-center gap-2 text-sm font-bold transition-colors hover:underline"
                  style={{ color: item.color }}
                >
                  Solicitar convênio <ArrowRight size={14} />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
